export default __webpack_public_path__ + "9bd9dcf2e33afe34c76ca567069e878e.png";